import { supabase } from "@/integrations/supabase/client";
import { analyticsAllowed } from "@/lib/cookie-consent";
import { getUtmParams } from "@/lib/utm";
import { getAiReferrer } from "@/lib/ai-referrer";

function getSessionId(): string {
  const key = "td_session_id";
  let id = sessionStorage.getItem(key);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(key, id);
  }
  return id;
}

export async function trackEvent(
  eventName: string,
  properties?: Record<string, unknown>,
  userId?: string,
): Promise<void> {
  if (!analyticsAllowed()) return;

  try {
    // Auto-attach UTM params + AI referrer (if any) to every event.
    // First-touch wins: both are stored once per session and follow the user
    // through signup, purchase, etc. so we can attribute conversions back
    // to the original AI citation or campaign.
    const utm = getUtmParams();
    const aiRef = getAiReferrer();
    const enrichedProperties = {
      ...properties,
      ...(Object.keys(utm).length > 0 ? { utm } : {}),
      ...(aiRef ? { ai_referrer: aiRef.source, ai_referrer_via: aiRef.via } : {}),
    };

    const { error } = await supabase.from("analytics_events" as any).insert({
      event_name: eventName,
      session_id: getSessionId(),
      user_id: userId ?? null,
      properties: enrichedProperties,
    } as any);
    if (error) console.warn("[analytics]", error.message);
  } catch (e) {
    console.warn("[analytics]", e);
  }
}
